<template>
  <div>
    <h1 class="About-FirstTitle" style="background-color:#AFEEEE;color:black;">{{ About.Title }}</h1>
    <div class="About">
      <!--                  <div class="Navigator">-->
      <!--                  </div>-->
      <div class="Update">{{ About.Update }}{{ About.Publications.Update }}</div>
      <h2 class="About-SecondTitle" style="color:indianred;"><i class="fa fa-mail-forward"
                                                                style="color:indianred;"></i>{{
          About.News.Title
        }}
      </h2>
      <div class="News">
        <div class="NewsContent" v-for="content in About.News.Content">
          <p class="NewsTitle"><b class="NewsID">{{ About.News.Content.indexOf(content) + 1 }})</b><i
              v-html="content.Title"></i></p>
          <b class="NewsDate">{{ content.Date }}</b>
        </div>
      </div>

      <div id="Introduction">
        <h2 class="About-SecondTitle" style="color:#00BFFF;"><i class="fa fa-bell-o"
                                                                style="color:#00BFFF;"></i>{{
            About.Introduction.Title
          }}
        </h2>
        <div class="About-HeadImage">
          <p>
            <a href="mailto:cswangjishu@ynnu.edu.cn"><i class="fa fa-envelope-o" title="邮箱"></i></a>
            <a href="https://scholar.google.com/citations?user=YjdfQjcAAAAJ" target="_blank"><i class="fa fa-mortar-board" title="谷歌学术"></i></a>
            <a href="https://github.com/JiShuWang" target="_blank"><i class="fa fa-github" title="Github"></i></a>
            <a href="https://www.kaggle.com/loveffc/datasets" target="_blank"><i class="fa fa-database" title="Kaggle"></i></a>
          </p>
        </div>
        <div class="About-Content2" id="SelfIntroduction" v-html="About.Blog.Content"></div>
        <!--                                <p class="About-Content"><b>{{ About.Introduction.Name }}</b></p>-->
        <div class="About-Content2" v-html="About.Introduction.Career"></div>
        <table>
          <td class="ArticleContent"><p class="ArticleTitle" v-html="About.Introduction.Lecture"></p></td>
        </table>
        <table>
          <td class="ArticleContent"><p class="ArticleTitle" v-html="About.Introduction.PhD"></p><b
              class="SelfAuthor">{{ About.Introduction.PhDSupervisor }}</b></td>
        </table>
        <table>
          <td class="ArticleContent"><p class="ArticleTitle" v-html="About.Introduction.Graduate"></p><b
              class="SelfAuthor">{{ About.Introduction.GraduateSupervisor }}</b></td>
        </table>
        <table>
          <td class="ArticleContent"><p class="ArticleTitle" v-html="About.Introduction.Undergraduate"></p>
          </td>
        </table>
      </div>

      <div id="Publications">
        <h2 class="About-SecondTitle" style="color:#008B45;"><i class="fa fa-paper-plane-o"
                                                                style="color:#008B45;"></i>{{
            About.Publications.Publications
          }}
        </h2>
        <div class="Count">
          <p class="IF"><span class="title" v-html="About.Publications.Trans"></span>
            <span style="font-weight: bolder;color:midnightblue" class="value">{{ About.Publications.Count.Trans }}</span></p>
          <p class="Cite"><span class="title">{{ About.Publications.CCF }}</span>
            <span style="font-weight: bolder;color:midnightblue" class="value">{{ About.Publications.Count.CCF }}</span></p>
          <p class="Cite"><span class="title">{{ About.Publications.HIndex }}</span>
            <span style="font-weight: bolder;color:midnightblue" class="value">{{ About.Publications.Count.HIndex }}</span></p>
          <p class="IF"><span class="title">{{ About.Publications.TotalCites }}</span>
            <span style="font-weight: bolder;color:midnightblue" class="value">{{ About.Publications.Count.TotalCite }}</span></p>
          <b class="GoogleScholar"><i class=""></i><a target="_blank"
                                                      href="https://webofscience.clarivate.cn/wos/author/record/46497250"
                                                      style="float: none">{{ About.Publications.WoS }}</a></b>
          <b class="DBLP"><a target="_blank"
                             href="https://dblp.dagstuhl.de/pid/303/5438.html"
                             style="float: none">{{ About.Publications.DBLP }}</a></b>
          <b class="ResearchGate"><a target="_blank"
                                     href="https://www.researchgate.net/profile/Jishu-Wang"
                                     style="float: none">{{ About.Publications.ResearchGate }}</a></b>
          <b class="ORCID"><a target="_blank"
                                     href="https://orcid.org/0000-0001-5973-2415"
                                     style="float: none">{{ About.Publications.ORCID }}</a></b>
          <div class="About-Tips"><b v-html="About.Publications.Tips"></b></div>
        </div>
        <p class="About-Content"><b
            class="SelfAuthor">{{ About.Publications.FirstAuthor }} ({{ About.Publications.First.length }})</b></p>
        <table style="border: none">
          <tr>
            <th class="Title">{{About.Publications.Title}}</th>
            <th class="Authors">{{About.Publications.Authors}}</th>
            <th class="Publications">{{About.Publications.Journal}}</th>
          </tr>
          <tr v-for="content in About.Publications.First">
            <th class="Title" style="text-align: justify">[{{About.Publications.First.indexOf(content)+1}}] {{content.Title}}<span
                v-if="content.State==='Reviewing'"><sup
                class="Reviewing">(<i
                class="fa fa-spin fa-hourglass-2"></i>{{ content.Year }} {{
                About.Publications.Reviewing
              }})</sup></span>
              <span v-else-if="content.State==='Accepted'"><sup
                  class="Accepted">(<i
                  class="fa fa-flag"></i>{{ content.Year }} {{
                  About.Publications.Accepted
                }})</sup></span>
              <span v-else-if="content.State==='Article'"><sup><a
                  class="Article" :href="content.Link" target="_blank">(<i
                  class="fa fa-arrow-circle-down"></i>{{ content.Date }} {{
                  About.Publications.Article
                }})</a></sup></span><sup class="ArticleCite"> (引用数:
                {{ content.Cite }})</sup></th>
            <th class="Authors" v-html="content.Authors" style="text-align: justify"></th>
            <th class="Journal" style="text-align: justify"><b class="Source" v-html="content.Journal"></b><p style="text-align: justify"><span v-html="content.Level"
                                                                                                           style="background-color: deepskyblue;"></span><span
                v-if="content.Area!==''" v-html="content.Area+' ('+content.JCR+')'"
                style="background-color: darkorange;"></span><span v-if="content.TOP!==''" v-text="content.TOP" class="TOP"></span>
              <span v-if="content.CCF!==''" v-text="content.CCF" class="CCF"></span><span
                  v-if="content.IF!==''" v-html="content.IF" style="background-color: limegreen;"></span></p>
            </th>
          </tr>
        </table>
        <p class="About-Content" v-on:click="CoAuthor('Publications')"><b>{{ About.Publications.CoAuthor }}
          ({{ About.Publications.Co.length }})<i :class="Data.CoAuthor.Publications.class" style="font-size:1.5em"></i></b>
        </p>
        <div v-if="Data.CoAuthor.Publications.display">
          <table style="border: none">
            <tr>
              <th class="Title">{{About.Publications.Title}}</th>
              <th class="Authors">{{About.Publications.Authors}}</th>
              <th class="Publications">{{About.Publications.Journal}}</th>
            </tr>
            <tr v-for="content in About.Publications.Co">
              <th class="Title" style="text-align: justify">[{{ About.Publications.Co.indexOf(content)+1}}] {{content.Title}}<span
                  v-if="content.State==='Reviewing'"><sup
                  class="Reviewing">(<i
                  class="fa fa-spin fa-hourglass-2"></i>{{ content.Year }} {{
                  About.Publications.Reviewing
                }})</sup></span>
                <span v-else-if="content.State==='Accepted'"><sup
                    class="Accepted">(<i
                    class="fa fa-flag"></i>{{ content.Year }} {{
                    About.Publications.Accepted
                  }})</sup></span>
                <span v-if="content.State==='Article'"><sup><a
                    class="Article" :href="content.Link" target="_blank">(<i
                    class="fa fa-arrow-circle-down"></i>{{ content.Date }} {{
                    About.Publications.Article
                  }})</a></sup></span></th>
              <th class="Authors" v-html="content.Authors" style="text-align: justify"></th>
              <th class="Journal" style="text-align: justify"><b class="Source" v-html="content.Journal"></b><p style="text-align: justify"><span v-html="content.Level"
                                                              style="background-color: deepskyblue;"></span><span
                  v-if="content.Area!==''" v-html="content.Area+' ('+content.JCR+')'"
                  style="background-color: darkorange;"></span><span v-if="content.TOP!==''" v-text="content.TOP" class="TOP"></span>
                <span v-if="content.CCF!==''" v-text="content.CCF" class="CCF"></span><span
                    v-if="content.IF!==''" v-html="content.IF" style="background-color: limegreen;"></span></p>
              </th>
            </tr>
          </table>
        </div>
      </div>

      <div id="Competitions">
        <h2 class="About-SecondTitle" style="color:#8968CD;"><i class="fa fa-trophy" style="color:#8968CD;"></i>{{
            About.Competitions.Title
          }}
          ({{ About.Competitions.Undergraduate.Content.length + About.Competitions.Graduate.Content.length + About.Competitions.PhD.Content.length }})</h2>
        <p class="About-Content"><b>{{About.Competitions.Tearcher.Title}} ({{ About.Competitions.Tearcher.Content.length }})</b></p>
        <p class="About-Content2" v-for="content in About.Competitions.Tearcher.Content">
          <b>[{{ About.Competitions.Tearcher.Content.indexOf(content)+1}}]</b><span v-html="content.Name"></span><span v-html="content.Level"></span><span>{{
            content.Date
          }}</span>
        </p>
        <p class="About-Content"><b>{{About.Competitions.PhD.Title}} ({{ About.Competitions.PhD.Content.length }})</b></p>
        <p class="About-Content2" v-for="content in About.Competitions.PhD.Content">
          <b>[{{ About.Competitions.PhD.Content.indexOf(content)+1}}]</b><span v-html="content.Name"></span><span v-html="content.Level"></span><span>{{
            content.Date
          }}</span>
        </p>
        <p class="About-Content"><b>{{About.Competitions.Graduate.Title}} ({{ About.Competitions.Graduate.Content.length }})</b></p>
        <p class="About-Content2" v-for="content in About.Competitions.Graduate.Content">
          <b>[{{ About.Competitions.Graduate.Content.indexOf(content)+1}}]</b><span v-html="content.Name"></span><span v-html="content.Level"></span><span>{{
            content.Date
          }}</span>
        </p>
        <p class="About-Content"><b>{{About.Competitions.Undergraduate.Title}} ({{ About.Competitions.Undergraduate.Content.length }})</b></p>
        <p class="About-Content2" v-for="content in About.Competitions.Undergraduate.Content">
          <b>[{{ About.Competitions.Undergraduate.Content.indexOf(content)+1}}]</b><span v-html="content.Name"></span><span v-html="content.Level"></span><span>{{
            content.Date
          }}</span>
        </p>
      </div>

      <div id="Funds">
        <h2 class="About-SecondTitle" style="color:#00CED1;"><i class="fa fa-puzzle-piece"
                                                                style="color:#00CED1;"></i>{{
            About.Funds.Title
          }} ({{ About.Funds.Leader.Content.length+About.Funds.Hold.Content.length}})
        </h2>
        <p class="About-Content" style="color: red"><b>{{ About.Funds.Leader.Title }}
          ({{ About.Funds.Leader.Content.length }})</b></p>
        <p class="About-Content2" v-for="content in About.Funds.Leader.Content">
          <b>[{{ About.Funds.Leader.Content.indexOf(content)+1 }}]{{
              content.Name
            }}</b>{{
            content.Type
          }}{{ content.Funding }}<b>{{ content.Date }}</b>
        </p>
        <p class="About-Content" style="color: red"><b>{{ About.Funds.Hold.Title }}
          ({{ About.Funds.Hold.Content.length }})</b></p>
        <p class="About-Content2" v-for="content in About.Funds.Hold.Content">
          <b>[{{ About.Funds.Hold.Content.indexOf(content)+1 }}]{{
              content.Name
            }}</b>{{
            content.Type
          }}{{ content.Funding }}<b>{{ content.Date }}</b>
        </p>
<!--        <p class="About-Content" v-on:click="CoAuthor('Funds')"><b>{{ About.Funds.Member.Title }}-->
<!--          ({{ About.Funds.Member.Content.length }})<i :class="Data.CoAuthor.Funds.class"-->
<!--                                                      style="font-size:1.5em"></i></b>-->
<!--        </p>-->
<!--        <div v-if="Data.CoAuthor.Funds.display">-->
<!--          <p class="About-Content2" v-for="content in About.Funds.Member.Content">-->
<!--            <b>[{{-->
<!--                About.Funds.Member.Content.indexOf(content)+1-->
<!--              }}]</b>{{ content.Name }}{{-->
<!--              content.Type-->
<!--            }}{{ content.Funding }}<b>{{ content.Date }}</b>-->
<!--          </p>-->
<!--        </div>-->
      </div>

      <div id="Patents">
        <h2 class="About-SecondTitle" style="color:red;"><i class="fa fa-key"
                                                            style="color:red;"></i>{{
            About.Patents.Title
          }} ({{ About.Patents.First.Content.length }})
        </h2>
        <p class="About-Content" style="color: red"><b>{{ About.Patents.First.Title }}
          ({{ About.Patents.First.Content.length }})</b></p>
        <p class="About-Content2" v-for="content in About.Patents.First.Content">
          <b>[{{ About.Patents.First.Content.indexOf(content)+1 }}]{{
              content.Name
            }}</b>{{
            content.ID
          }}{{ content.State }}
        </p>
<!--        <p class="About-Content" v-on:click="CoAuthor('Patents')"><b>{{ About.Patents.Co.Title }}-->
<!--          ({{ About.Patents.Co.Content.length }})<i :class="Data.CoAuthor.Patents.class"-->
<!--                                                    style="font-size:1.5em"></i></b></p>-->
<!--        <div v-if="Data.CoAuthor.Patents.display">-->
<!--          <p class="About-Content2" v-for="content in About.Patents.Co.Content">-->
<!--            <b>[{{ About.Patents.Co.Content.indexOf(content)+1 }}]</b>{{-->
<!--              content.Name-->
<!--            }}{{-->
<!--              content.ID-->
<!--            }}{{ content.State }}-->
<!--          </p>-->
<!--        </div>-->
      </div>

      <div id="Copyrights">
        <h2 class="About-SecondTitle" style="color:#20B2AA;"><i class="fa fa-code" style="color:#20B2AA;"></i>{{
            About.CopyRights.Title
          }} ({{ About.CopyRights.First.Content.length + About.CopyRights.Co.Content.length }})
        </h2>
        <p class="About-Content" style="color: red"><b>{{ About.CopyRights.First.Title }}
          ({{ About.CopyRights.First.Content.length }})</b></p>
        <p class="About-Content2" v-for="content in About.CopyRights.First.Content">
          <b>[{{ About.CopyRights.First.Content.indexOf(content)+1 }}]</b>{{ content.Name }}{{
            content.ID
          }}
        </p>
<!--        <p class="About-Content"><b>{{ About.CopyRights.Co.Title }} ({{-->
<!--            About.CopyRights.Co.Content.length-->
<!--          }})<i :class="Data.CoAuthor.Copyrights.class" style="font-size:1.5em" v-on:click="CoAuthor('Copyrights')"></i></b>-->
<!--        </p>-->
<!--        <div v-if="Data.CoAuthor.Copyrights.display">-->
<!--          <p class="About-Content2" v-for="content in About.CopyRights.Co.Content">-->
<!--            <b>[{{ About.CopyRights.Co.Content.indexOf(content)+1 }}]</b>{{ content.Name }}{{-->
<!--              content.ID-->
<!--            }}-->
<!--          </p>-->
<!--        </div>-->
      </div>

      <div id="Certificates">
        <h2 class="About-SecondTitle" style="color:#D2691E;"><i class="fa fa-certificate"
                                                                style="color:#D2691E;"></i>{{
            About.Certificates.Title
          }} ({{ About.Certificates.Content.length }})</h2>
        <p class="About-Content2" v-for="content in About.Certificates.Content">
          <b>[{{ About.Certificates.Content.indexOf(content) + 1 }}]</b>{{ content.Name }}{{
            content.Date
          }}
        </p>
      </div>

      <div id="Rewards">
        <h2 class="About-SecondTitle" style="color:#B22222;"><i class="fa fa-star"
                                                                style="color:#B22222;"></i>{{
            About.Rewards.Title
          }} ({{ About.Rewards.Undergraduate.Content.length + About.Rewards.Graduate.Content.length + About.Rewards.PhD.Content.length }})</h2>
        <p class="About-Content"><b>{{About.Rewards.Teacher.Title}} ({{ About.Rewards.Teacher.Content.length }})</b></p>
        <p class="About-Content2" v-for="content in About.Rewards.Teacher.Content">
          <b>[{{ About.Rewards.Teacher.Content.indexOf(content)+1}}]</b><span v-html="content.Name"></span><span>{{
            content.Date
          }}</span>
        </p>
        <p class="About-Content"><b>{{About.Rewards.PhD.Title}} ({{ About.Rewards.PhD.Content.length }})</b></p>
        <p class="About-Content2" v-for="content in About.Rewards.PhD.Content">
          <b>[{{ About.Rewards.PhD.Content.indexOf(content)+1}}]</b><span v-html="content.Name"></span><span>{{
            content.Date
          }}</span>
        </p>
        <p class="About-Content"><b>{{About.Rewards.Graduate.Title}} ({{ About.Rewards.Graduate.Content.length }})</b></p>
        <p class="About-Content2" v-for="content in About.Rewards.Graduate.Content">
          <b>[{{ About.Rewards.Graduate.Content.indexOf(content)+1}}]</b><span v-html="content.Name"></span><span>{{
            content.Date
          }}</span>
        </p>
        <p class="About-Content"><b>{{About.Rewards.Undergraduate.Title}} ({{ About.Rewards.Undergraduate.Content.length }})</b></p>
        <p class="About-Content2" v-for="content in About.Rewards.Undergraduate.Content">
          <b>[{{ About.Rewards.Undergraduate.Content.indexOf(content)+1}}]</b><span v-html="content.Name"></span><span>{{
            content.Date
          }}</span>
        </p>
      </div>

      <div id="Review">
        <h2 class="About-SecondTitle" style="color:limegreen;"><i class="fa fa-envelope-open-o"
                                                                style="color:limegreen"></i>{{
            About.Review.Title
          }}</h2>
        <p class="About-Content"><b>{{About.Review.Publication.Title}}</b></p>
        <table style="border: none;">
          <tr>
            <th class="Name">{{About.Review.Publication.ID}}</th>
            <th class="Name">{{About.Review.Publication.Journal}}</th>
            <th class="Date">{{About.Review.Publication.Date}}</th>
            <th class="Address">{{About.Review.Publication.Address}}</th>
<!--            <th class="Date">{{About.Review.Journal.Area}}</th>-->
<!--            <th class="Date">{{About.Review.Journal.CCF}}</th>-->
<!--            <th class="Date">{{About.Review.Journal.IF}}</th>-->
<!--            <th class="Date">{{About.Review.Journal.Duration}}</th>-->
          </tr>
          <tr v-for="content in About.Review.Publication.Review.IEEE">
            <th class="Name" style="text-align: center">{{ About.Review.Publication.Review.IEEE.indexOf(content)+1}}</th>
            <th class="Name" style="text-align: justify;font-weight: normal" v-html="content.Name"></th>
            <th class="Date" style="text-align: center;font-weight: normal">{{content.Date}}</th>
            <th>IEEE</th>
          </tr>
          <tr v-for="content in About.Review.Publication.Review.Elsevier">
            <th class="Name" style="text-align: center">{{ About.Review.Publication.Review.Elsevier.indexOf(content)+1}}</th>
            <th class="Name" style="text-align: justify;font-weight: normal" v-html="content.Name"></th>
            <th class="Date" style="text-align: center;font-weight: normal">{{content.Date}}</th>
            <th>Elsevier</th>
          </tr>
          <tr v-for="content in About.Review.Publication.Review.Springer">
            <th class="Name" style="text-align: center">{{ About.Review.Publication.Review.Springer.indexOf(content)+1}}</th>
            <th class="Name" style="text-align: justify;font-weight: normal" v-html="content.Name"></th>
            <th class="Date" style="text-align: center;font-weight: normal">{{content.Date}}</th>
            <th>Springer</th>
          </tr>
        </table>

        <table style="border: none;">
          <tr>
            <th class="Name">{{About.Review.Publication.ID}}</th>
            <th class="Name">{{About.Review.Publication.Conference}}</th>
            <th class="Date">{{About.Review.Publication.Date}}</th>
            <th class="Address">{{About.Review.Publication.Address}}</th>
            <!--            <th class="Date">{{About.Review.Journal.Area}}</th>-->
            <!--            <th class="Date">{{About.Review.Journal.CCF}}</th>-->
            <!--            <th class="Date">{{About.Review.Journal.IF}}</th>-->
            <!--            <th class="Date">{{About.Review.Journal.Duration}}</th>-->
          </tr>
          <tr v-for="content in About.Review.Publication.Review.Conference">
            <th class="Name" style="text-align: center">{{ About.Review.Publication.Review.Conference.indexOf(content)+1}}</th>
            <th class="Name" style="text-align: justify;font-weight: normal" v-html="content.Name"></th>
            <th class="Date" style="text-align: center;font-weight: normal">{{content.Date}}</th>
            <th>{{content.Address}}</th>
          </tr>
        </table>
      </div>

<!--                  <div id="Lession">-->
<!--                      <h2 class="About-SecondTitle" style="color:#8B7500;"><i class="fa fa-bookmark"-->
<!--                                                                              style="color:#8B7500;"></i>课程设计</h2>-->
<!--                      <p class="About-Content2"><b>1.C：</b>学生管理系统（控制台程序）-860行代码，2016年7月-C语言程序设计（课程设计）.</p>-->
<!--                      <p class="About-Content2"><b>2.Java：</b>计算器（桌面软件）-900行代码，涉及Java-Swing技术，2016年12月-Java语言程序设计（课程设计）.<a-->
<!--                          href="https://www.loveffc.cn/2016%e5%b9%b412%e6%9c%88-java%e8%af%ad%e8%a8%80%e7%a8%8b%e5%ba%8f%e8%ae%be%e8%ae%a1%ef%bc%88%e8%af%be%e7%a8%8b%e8%ae%be%e8%ae%a1%ef%bc%89"-->
<!--                          title="查看代码详情"> more</a></p>-->
<!--                      <p class="About-Content2"><b>3.C#：</b>商店管理系统（桌面软件）-6400行代码，涉及C#-WPF技术，2017年12月-软件工程（课程设计）.</p>-->
<!--                      <p class="About-Content2"><b>4.C#：</b>学生管理系统（桌面软件）-2600行代码，涉及C#-Winform、C#-WPF技术，2017年12月-C#语言程序设计（课程设计）.-->
<!--                      </p>-->
<!--                      <p class="About-Content2"><b>5.Java、HTML、CSS、JS：</b>博客乐园系统（网站）-3500行代码，涉及JSP+Servlet技术，2018年6月-JavaEE开发技术（课程设计）.-->
<!--                      </p>-->
<!--                      <p class="About-Content2"><b>6.C#：</b>无限活力游戏（桌面软件）-2500行代码，涉及C#-WPF技术，2018年6月-算法分析与设计（课程设计）.</p>-->
<!--                      <p class="About-Content2"><b>7.Java、HTML、CSS、JS：</b>网络相册系统（网站）-3800行代码，涉及JSP+Servlet技术，2018年12月-软件项目管理（课程设计）.-->
<!--                      </p>-->
<!--                      <p class="About-Content2"><b>8.PHP、HTML、CSS、JS：</b>昆明学院官方网站（网站）-3800行代码，涉及WordPress、自适应、响应式等技术，2019年5月-基于WordPress的校园网站设计与实现（毕业设计）.-->
<!--                      </p>-->
<!--                  </div>-->


<!--                  <div id="Spare">-->
<!--                      <h2 class="About-SecondTitle" style="color:#8B658B;"><i class="fa fa-bookmark-o"-->
<!--                                                                              style="color:#8B658B;"></i>课外代码</h2>-->
<!--                      <p class="About-Content2"><b style="font-weight:bolder;color:#8B658B;">1.Java：</b>篮球计分系统（桌面软件）-1200行代码，涉及Java-Swing技术，2017年10月-个人.<a-->
<!--                          href="https://www.loveffc.cn/2017%e5%b9%b410%e6%9c%88-%e7%af%ae%e7%90%83%e8%ae%a1%e5%88%86%e7%b3%bb%e7%bb%9f%ef%bc%88%e9%97%b2%e6%9a%87%e6%97%b6%e5%85%89%ef%bc%89"-->
<!--                          title="查看代码详情"> more</a></p>-->
<!--                      <p class="About-Content2"><b style="font-weight:bolder;color:#8B658B;">2.HTML、CSS、JS：</b>昆明学院评建网（网站）-2600行代码，<a-->
<!--                          href="https://pjb.kmu.edu.cn">域名：https://pjb.kmu.edu.cn</a>，2018年4月-昆明学院教务处.</p>-->
<!--                      <p class="About-Content2"><b style="font-weight:bolder;color:#8B658B;">3.HTML、CSS、JS：</b>昆明家教中心（网站）-2400行代码，<a-->
<!--                          href="https://www.kmujj.cn">域名：https://www.kmujj.cn</a>，2018年5月-个人.</p>-->
<!--                      <p class="About-Content2"><b style="font-weight:bolder;color:#8B658B;">4.PHP、HTML、CSS、JS：</b>建水风土人情（网站）-4200行代码，涉及WordPress、自适应技术，<a-->
<!--                          href="https://coverged.ynu-news.com/jianshui">域名：https://coverged.ynu-news.com/jianshui</a>，2019年10月-云南大学新闻学院.-->
<!--                      </p>-->
<!--                      <p class="About-Content2"><b style="font-weight:bolder;color:#8B658B;">5.C#：</b>GDI+绘图（桌面软件），CAD绘图软件-元件部分，涉及C#、GDI+技术，2020年3月-昆明鑫牛科技.<a-->
<!--                          href="https://www.loveffc.cn/c-gdi-1展示一个demo" title="查看代码详情"> more</a></p>-->
<!--                  </div>-->

      <div class="Slider">
        <!--                <p><a href="#Blog">{{ About.Blog.Title }}</a></p>-->
        <li><a href="#Introduction">{{ About.Introduction.Title }}</a></li>
        <li><a href="#Publications">{{ About.Publications.MainTitle }}</a></li>
        <li><a href="#Competitions">{{ About.Competitions.Title }}</a></li>
        <li><a href="#Funds">{{ About.Funds.Title }}</a></li>
        <li><a href="#Patents">{{ About.Patents.Title }}</a></li>
        <li><a href="#Copyrights">{{ About.CopyRights.Title }}</a></li>
        <li><a href="#Certificates">{{ About.Certificates.Title }}</a></li>
        <li><a href="#Rewards">{{ About.Rewards.Title }}</a></li>
        <!--                      <p><a href="#Lession">课设</a></p>-->
        <!--                      <p><a href="#Spare">代码</a></p>-->
        <li><a href="#Review">{{ About.Review.Title }}</a></li>
      </div>
    </div>
  </div>
</template>

<script>
var Data = {
  CoAuthor: {
    Publications: {
      display: false,
      class: "fa fa-angle-down"
    },
    Funds: {
      display: false,
      class: "fa fa-angle-down"
    },
    Patents: {
      display: false,
      class: "fa fa-angle-down"
    },
    Copyrights: {
      display: false,
      class: "fa fa-angle-down"
    }
  }
};
export default {
  name: "About",
  data() {
    return {
      Data: Data
    }
  },
  methods: {
    CoAuthor: function (id) {
      Data.CoAuthor[id].display = !Data.CoAuthor[id].display;
      if (Data.CoAuthor[id].class === "fa fa-angle-down")
        Data.CoAuthor[id].class = "fa fa-angle-up";
      else
        Data.CoAuthor[id].class = "fa fa-angle-down";
    }
  },
  computed: {
    About: function () {
      return this.$store.state.LANGUAGECONTENT.About;
    },
    Other: function () {
      return this.$store.state.LANGUAGECONTENT.Other;
    }
  }
}
</script>

<style src="../assets/StyleSheet/About.css" scoped>

</style>